export default __webpack_public_path__ + "static/media/element_78.d8c5e844.jpg";